import styled from 'styled-components'

export const TrabalheConoscoWrapper = styled.div`
  display: flex;
  background: url(https://imagens-site-riber.s3.sa-east-1.amazonaws.com/trabalhe_conosco_6.png)
    no-repeat;
  background-size: cover;
  min-height: 100vh;

  & .navbar {
    background: var(--branco);
  }

  & .container-banner {
    display: flex;
    margin-top: 80px;
    margin-bottom: 40px;
  }

  & .img-banner {
    width: 100%;
    max-width: 1200px;
  }

  & .title {
    font-size: 3rem;
    line-height: 3.2rem;
    font-weight: 700;
    color: var(--branco);
    margin-bottom: 1.5rem;
  }

  & .subtitle {
    font-size: 20px;
    font-weight: 700;
    color: var(--branco);
  }

  & h2 {
    font-size: 1.7rem;
    font-weight: 700;
    color: var(--branco);
  }

  & .container-beneficios {
    margin: 80px 0 0;
    max-width: 800px;
  }

  & .card-beneficio {
    background: #00bf63;
    border-radius: 36px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 100%;
    max-width: 200px;
    height: 100%;

    & img {
      margin-bottom: 1rem;
    }

    & label {
      color: var(--branco);
      font-weight: 700;
      font-size: 1.5rem;
      line-height: 1.5rem;
      margin-bottom: 1rem;
      text-align: center;
    }

    & span {
      color: var(--branco);
      font-weight: 600;
      font-size: 0.7rem;
      text-align: center;
    }

    & .trabalhe_conosco_img-lateral {
      width: 50px;
    }
  }

  @media screen and (max-width: 991px) {
    & .img-banner {
      max-width: 400px;
      margin-bottom: 40px;
    }

    & .title {
      font-size: 2.5rem;
      line-height: 2.8rem;
    }

    & .subtitle {
      font-size: 1.2rem;
    }

    & h2 {
      font-size: 1.5rem;
    }

    & .card-beneficio label {
      font-size: 1.3rem;
    }

    & .card-beneficio span {
      font-size: 0.6rem;
    }

    & .trabalhe_conosco_img-lateral {
      width: 40px;
    }
  }

  @media screen and (max-width: 768px) {
    .container-beneficios {
      padding: 20px 16px;
      text-align: center;
    }

    .container-beneficios .row {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
    }

    .card-beneficio {
      width: 100%;
      margin-bottom: 16px;
    }

    .btn-vagas {
      width: 200px !important;
      display: block;
      margin: 32px auto 0 auto;
    }
  }

  @media screen and (max-width: 480px) {
    & .container-beneficios {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      margin: 0 auto;
    }

    & .card-beneficio {
      margin-bottom: 20px;
      align-self: center;
    }
    .btn-vagas {
      width: 100%;
      max-width: 300px;
      margin: 0 auto;
      display: block;
    }
    & h2 {
      text-align: center;
    }
  }
`
